
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// This is just a redirect page to the /docs path
const DocsIndexPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate("/docs/");
  }, [navigate]);
  
  return <div>Redirecting to documentation...</div>;
};

export default DocsIndexPage;
